import React from "react";

import blueprintIcon from "@src/assets/svg/blueprint-icon.svg";

import styles from "./blueprint-info-gradient-wrapper.module.scss";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { transformDateTime } from "@src/components/organisms/modals/blueprints/helpers/transform-date-time";
import { useI18N } from "@src/language/language-context";

const cssClassName = "blueprint-info-gradient-wrapper";

interface BlueprintInfoGradientWrapperPropTypes {
  blueprint: BlueprintsArrayObjectTypes;
}

export const BlueprintInfoGradientWrapper = ({
  blueprint,
}: BlueprintInfoGradientWrapperPropTypes) => {
  const i18n = useI18N();

  const texts = {
    dateAndAuthorTemplate: i18n(
      "modules.replaceBlueprintModal.dateAndAuthorTemplate",
    ),
    blueprintIconAltText: i18n(
      "modules.replaceBlueprintModal.blueprintIconAltText",
    ),
  };

  const renderDateAndAuthor = () => {
    const modifiedTemplate = texts.dateAndAuthorTemplate
      .replace("{date}", transformDateTime(blueprint.created_at))
      .replace("{author}", blueprint.author);

    return modifiedTemplate;
  };

  return (
    <div className={styles[`${cssClassName}`]}>
      <div className={styles[`${cssClassName}__inner-wrapper`]}>
        <img src={blueprintIcon} alt={texts.blueprintIconAltText} />
        <div className={styles[`${cssClassName}__text-wrapper`]}>
          <p className={styles[`${cssClassName}__text-big`]}>
            {blueprint.name}
          </p>
          <p className={styles[`${cssClassName}__text-small`]}>
            {renderDateAndAuthor()}
          </p>
        </div>
      </div>
    </div>
  );
};
